export interface Point { x: number; y: number }

export class DragGesture {
  private start: Point | null = null;
  private dragging = false;
  readonly threshold = 10;
  readonly radius = 54;

  begin(point: Point): void { this.start = point; this.dragging = false; }
  move(point: Point): { dragging: boolean; origin: Point; vector: Point } | null {
    if (!this.start) return null;
    const dx = point.x - this.start.x;
    const dy = point.y - this.start.y;
    const distance = Math.hypot(dx, dy);
    if (!this.dragging && distance > this.threshold) this.dragging = true;
    const scale = distance > this.radius ? this.radius / distance : 1;
    return { dragging: this.dragging, origin: this.start, vector: { x: dx * scale / this.radius, y: dy * scale / this.radius } };
  }
  end(point: Point): { wasDrag: boolean; point: Point } { const wasDrag = this.dragging; this.start = null; this.dragging = false; return { wasDrag, point }; }
  cancel(): void { this.start = null; this.dragging = false; }
}
